import { render, staticRenderFns } from "./WishlistLogin.vue?vue&type=template&id=58eb3b2c&"
import script from "./WishlistLogin.vue?vue&type=script&lang=js&"
export * from "./WishlistLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconCircle: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconCircle.vue').default,AppButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppButton.vue').default})
